import axioInstance from "../../custom_utilities/AxiosInstance/axiosInstance";
import { getFormatForApi } from "../../custom_utilities/pyqFormatUtils";

const AITS_TESTLIST_URL =
  "https://learning.motion.ac.in/motioneducation/api/v1/practice_testlist";
  
  const AITS_SYLLABUS_URL =
  "https://learning.motion.ac.in/motioneducation/api/v1/get/aits/syllabus";


const aitsApi = {
  getAitsTestList: async ({
    paperType,
    plannerId,
    plannerTestType,
    year,
    format,
    categoryId,
    page = 1,
  }) => {
    const safePlannerId = plannerId ?? "";
    const safePlannerTestType = plannerTestType ?? "";
    const apiFormat = getFormatForApi({ format });
    const formatQuery = apiFormat ? `&format=${apiFormat}` : "";
    const res = await axioInstance.get(
      `${AITS_TESTLIST_URL}?paper_type=${paperType}&planner_id=${safePlannerId}&planner_test_type=${safePlannerTestType}&year=${year}${formatQuery}&category_id=${categoryId}&page=${page}`
    );
    return res.data;
  },

   getAitsSyllabus: async ({ paperId, plannerId }) => {
    const res = await axioInstance.get(
      `${AITS_SYLLABUS_URL}?paper_id=${paperId}&planner_id=${plannerId}`
    );
    return res.data;
  },
};

export default aitsApi;
